import { option } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { Option } from "fp-ts/es6/Option";
import { Maybe } from "../../../utils/fp/small-fp-utils";
import { UserAuthToken } from "../../../domain/auth/user-auth/auth-client";

type UnknownObject = {
  [key: string]: unknown;
};

export function readUserAuthToken(storageKey: string): Maybe<UserAuthToken> {
  return pipe(
    option.fromNullable(typeof window !== "undefined" ? window.localStorage.getItem(storageKey) : undefined),
    option.chain(str => safeParse<UnknownObject>(str)),
    option.chain(json => {
      if (
        typeof json.access_token === "string" &&
        typeof json.refresh_token === "string" &&
        typeof json.expires_in === "number" &&
        typeof json.expires_at === "number" &&
        typeof json.scope === "string" &&
        json.token_type === "Bearer"
      ) {
        return option.some<UserAuthToken>({
          access_token: json.access_token,
          refresh_token: json.refresh_token,
          expires_in: json.expires_in,
          expires_at: json.expires_at,
          scope: json.scope,
          token_type: "Bearer",
        });
      } else {
        return option.none;
      }
    }),
    option.toUndefined,
  );
}

export function persistUserAccessToken(storageKey: string, value: UserAuthToken) {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(storageKey, JSON.stringify(value));
  }
}

export function removeUserAccessToken(storageKey: string) {
  if (typeof window !== "undefined") {
    window.localStorage.removeItem(storageKey);
  }
}

function safeParse<T>(tJsonString: string): Option<T> {
  try {
    return option.some(JSON.parse(tJsonString));
  } catch {
    return option.none;
  }
}
